import { render } from "./TableStatisticsView.vue?vue&type=template&id=0f3298b4&scoped=true"
import script from "./TableStatisticsView.vue?vue&type=script&lang=js"
export * from "./TableStatisticsView.vue?vue&type=script&lang=js"

import "./TableStatisticsView.vue?vue&type=style&index=0&id=0f3298b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3298b4"]])

export default __exports__